import { useModal } from "core";
import { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";


export const useBlockPageBeforeUnload= (
    unloadSign: boolean, 
    callBack?: (val: boolean) => void, 
    excluded?: string[], 
    msg?: string, 
    title? : string, 
    buttonNames?: any
)  => {
    const modal = useModal();
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();

    const beforeUnloadCallback = useCallback((path: string) => {
        modal.show('not-saved-data', {
            path,
            callback: callBack,
            msgText: msg || t('not_saved_modal.common_title'),
            title: title || undefined,
            buttonNames: buttonNames || undefined
        })
    }, [modal, t])

    useEffect(() => {
        //@ts-ignore
        history.block((tx: any) => {
            const internal = location.pathname;
            const external = tx.pathname;
            const extParams = tx?.search;
            const sign = unloadSign;
            const excl = (excluded && !!excluded?.length && excluded?.find((i) => {
                return i === external
            } ))

            if (external !== internal && sign && !excl) {
                beforeUnloadCallback(`${external}${extParams || ''}`);
                return false;
            }
            return true;
        })
    }, [location, history, unloadSign, beforeUnloadCallback, excluded])

    return [];

}import { useModal } from "core";
import { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";


export const useBlockPageBeforeUnload= (
    unloadSign: boolean, 
    callBack?: (val: boolean) => void, 
    excluded?: string[], 
    msg?: string, 
    title? : string, 
    buttonNames?: any
)  => {
    const modal = useModal();
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();

    const beforeUnloadCallback = useCallback((path: string) => {
        modal.show('not-saved-data', {
            path,
            callback: callBack,
            msgText: msg || t('not_saved_modal.common_title'),
            title: title || undefined,
            buttonNames: buttonNames || undefined
        })
    }, [modal, t])

    useEffect(() => {
        //@ts-ignore
        history.block((tx: any) => {
            const internal = location.pathname;
            const external = tx.pathname;
            const extParams = tx?.search;
            const sign = unloadSign;
            const excl = (excluded && !!excluded?.length && excluded?.find((i) => {
                return i === external
            } ))

            if (external !== internal && sign && !excl) {
                beforeUnloadCallback(`${external}${extParams || ''}`);
                return false;
            }
            return true;
        })
    }, [location, history, unloadSign, beforeUnloadCallback, excluded])

    return [];

}